module.exports = __webpack_public_path__ + "img/left1.dc16c826.png";